import React, {FunctionComponent} from "react";
import WizardStep from "../WizardStep";
import statusAdditionalDisposal from "../../../images/Progress/weiteres-produkt_icn.svg";
import GradientButton from "../../../commonComponents/GradientButton";
import {Step} from "../../WizardMap";
import {useDispatch, batch} from "react-redux";
import {addCurrentDisposal, resetCurrentDisposal} from "../../state/disposalSlice";
import {useMediaQuery, useTheme} from "@material-ui/core";
import {NavigationProps} from "../../slideRouter/navigationHook";

const StepAdditionalDisposal: FunctionComponent<NavigationProps> = ({gotoPrevSlide, jumpTo, gotoNextSlide}) => {

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("xs"));

    const dispatch = useDispatch();

    const handleNoClicked = () => {
        dispatch(addCurrentDisposal());
        isXs ? gotoNextSlide(Step.CONTACT_INFO_MOBILE_1) : gotoNextSlide(Step.CONTACT_INFO);
    };

    const handleYesClicked = () => {
        batch(() => {
            dispatch(addCurrentDisposal());
            dispatch(resetCurrentDisposal());
        });
        jumpTo(Step.OBJECT_TYPE);
    };

    return (
        <WizardStep
            title={"Möchten Sie ein weiteres Produkt verkaufen?"}
            icon={statusAdditionalDisposal}
            backButton
            onBackClick={gotoPrevSlide}
        >
            <GradientButton
                text={"ja"}
                onClick={handleYesClicked}
                style={{marginBottom: 15}}
            />
            <GradientButton
                text={"nein"}
                onClick={handleNoClicked}
            />
        </WizardStep>
    );
};

export default StepAdditionalDisposal;
